import { isEmpty } from 'lodash-es'
import { PropType, defineComponent } from 'vue'

import { MsHeadline, MsText } from '@sunrise/components'
import { MsHydration } from '@sunrise/hydration'
import { contentByLabel, getCmsProperty, screenSizeDetection, useGlobalStore } from '@sunrise/shared'
import { MsTracking, addTracking } from '@sunrise/tracking'
import { Cms } from '@sunrise/types'

import MsItemSlider from '../../../../components/MsItemSlider/MsItemSlider.vue'
import MsMailAgentBanner from '../../../../components/MsMailAgentBanner/MsMailAgentBanner.vue'
import { MailAgentTrackingVariant } from '../../../../components/MsMailAgentModal/MsMailAgentModal.enum'
import MsRecommenderItem from '../../../../components/MsRecommenderItem/MsRecommenderItem.vue'
import { ComponentName } from '../../../../components/MsResultListItem/MsResultListItem.enum'
import MsResultListItem from '../../../../components/MsResultListItem/MsResultListItem.vue'

import { DecoratedEstate } from '../../../../ts/mapper/decoratedItemEstate.interface'
import { CmsElementProperty } from '../../../../ts/shared/enum/cms.enum'
import { SharedDataDetail } from '../../../../ts/shared/serviceProvider/detailServiceProvider.enum'

import { RecommenderServiceData } from '../M_RealEstate_Recommender.interface'
import { buildMlmTrackingData } from '../M_RealEstate_RecommenderTracking'

export default defineComponent({
    name: 'HydratedRecommender',
    components: {
        MsHeadline,
        MsText,
        MsResultListItem,
        MsRecommenderItem,
        MsMailAgentBanner,
        MsHydration,
        MsItemSlider,
    },
    props: {
        cmsContent: {
            type: Object as PropType<Cms.Content<RecommenderServiceData>>,
            required: true,
        },
    },
    setup(props) {
        const serviceData = useGlobalStore().sharedServiceData?.[SharedDataDetail.KEY] || props.cmsContent.serviceData
        const requestContext = useGlobalStore().requestContext
        const currentUrl = requestContext?.url.href || ''
        const hasItems = !isEmpty(serviceData.items)
        const privacyPoliceUrl = requestContext?.globalLinks.datenschutzerklaerung || ''

        const headline = contentByLabel(props.cmsContent, 'Überschrift')

        const pageSizeDesktop: number = getCmsProperty(CmsElementProperty.pageSizeDesktop, props.cmsContent, 5)
        const pageSizeMobile: number = getCmsProperty(CmsElementProperty.pageSizeMobile, props.cmsContent, 3)

        const { isScreenM } = screenSizeDetection()

        const truncateItemsByPageSize = (items: DecoratedEstate[]) =>
            items.slice(0, isScreenM.value ? pageSizeDesktop : pageSizeMobile)

        const items: DecoratedEstate[] = hasItems ? truncateItemsByPageSize(serviceData.items) : []

        const mlmTrackingData: MsTracking = buildMlmTrackingData(
            props.cmsContent.name,
            items,
            currentUrl,
            !!serviceData.isExposeeOnline,
        )

        const tracking = addTracking([mlmTrackingData])

        return {
            MailAgentTrackingVariant,
            headline,
            serviceData,
            currentUrl,
            truncateItemsByPageSize,
            tracking,
            hasItems,
            items,
            privacyPoliceUrl,
            ComponentName,
        }
    },
})
